import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {
  ChevronDown as KeyboardArrowDownIcon,
  ChevronUp as KeyboardArrowUpIcon,
} from 'lucide-react';
import { Typography } from '@material-tailwind/react';
import TablePagination from '@mui/material/TablePagination';
import React, { useMemo, useState } from 'react';
import TableNotFound from './TableNotFound';
import { useSelector } from 'react-redux';
import { ProdutoModalInfo } from '../Modal/ProdutoModalInfo';
import { overflowMui } from '../ThemeMode/stylesMui';
import LinearProgress from '@mui/material/LinearProgress';

const cellTable = {
  fontWeight: 'normal',
  padding: '0 16px',
};

const thead = 'font-semibold text-sm uppercase text-black';

function Row(props) {
  const { row, handleViewProduct, open, setOpen, index } = props;

  const valorTotal = useMemo(() => {
    return (quantidade, valor) => {
      const valorCorrigido = parseFloat(valor.replace(',', '.')); // Converte corretamente
      const total = quantidade * valorCorrigido; // Faz a multiplicação
      return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };
  }, []);
  return (
    <>
      <TableRow
        onClick={() => setOpen(open === index ? false : index)}
        sx={{
          backgroundColor: open === index ? 'rgba(0, 0, 0, 0.2)' : '',
          cursor: 'pointer',
        }}
      >
        <TableCell style={{ ...cellTable, width: '200' }}>
          <Typography className={thead} color="white">
            {row.numeroPedido}
          </Typography>
        </TableCell>
        <TableCell style={{ ...cellTable, minWidth: '40%' }} align="left">
          <Typography variant="small" className={thead}>
            {row.idCompra}
          </Typography>
        </TableCell>
        <TableCell style={cellTable} align="right">
          <Typography className={thead} color="white">
            {row.data_entrada}
          </Typography>
        </TableCell>
        <TableCell style={cellTable} align="right">
          <IconButton aria-label="expand row" size="small">
            {open ? <KeyboardArrowUpIcon color="black" /> : <KeyboardArrowDownIcon color="black" />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, padding: 0 }} colSpan={4}>
          <Collapse in={open === index} timeout="auto" unmountOnExit className="w-[99%] mx-auto">
            <Box sx={{ margin: 0 }}>
              <Table size="small" aria-label="purchases" sx={{ border: '2px solid black' }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: '5%' }}>
                      <Typography color="white" className="font-bold ">
                        QTD
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ width: '60%' }}>
                      <Typography color="white" className="font-bold" align="left">
                        Produto
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ width: '10%' }}>
                      <Typography color="white" className="font-bold">
                        Valor (R$)
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ width: '10%' }}>
                      <Typography color="white" className="font-bold">
                        Valor total (R$)
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.produtos.map((historyRow, index) => (
                    <TableRow key={index} hover>
                      <TableCell style={{ width: 50 }}>
                        <Typography variant="small" color="black" className="font-normal">
                          {historyRow.quantidade}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="small"
                          className=" font-bold uppercase hover:underline hover:text-cyan-800 inline cursor-pointer"
                          onClick={() => handleViewProduct(historyRow)}
                        >
                          {historyRow.produto}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography
                          variant="small"
                          color="black"
                          className="font-normal whitespace-nowrap"
                        >
                          R$ {historyRow.preco}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography
                          variant="small"
                          color="black"
                          className="font-normal whitespace-nowrap"
                        >
                          {valorTotal(historyRow.quantidade, historyRow.preco)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}

                  <TableRow sx={{ bgcolor: 'transparent' }}>
                    <TableCell
                      variant="footer"
                      align="right"
                      colSpan={4}
                      sx={{ borderColor: 'transparent', padding: '0px 0px' }}
                    >
                      <Typography
                        color="black"
                        className="font-semibold inline-block bg-yellow-300  px-2"
                      >
                        Total: R$ {row.valorTotal}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default function TableHistoricEntrada({ rows = [], inputSearch, loading }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const { productos } = useSelector((state) => state.product);
  const [open, setOpen] = useState(false);

  const [viewProduct, setViewProduct] = useState(false);

  const handleViewProduct = (produto) => {
    const view = productos.find((produt) => produt.winthor === produto.produtoWinthor) || null;
    setViewProduct(view);
  };

  const handleCloseViewProdut = () => {
    setViewProduct(false);
  };

  React.useEffect(() => {
    setPage(0);
  }, [rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOpen(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <Paper
        sx={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <TableContainer
          sx={{
            height: '100%',
            minHeight: 550,
            maxHeight: '90%',
            ...overflowMui(),
          }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>Pedido</TableCell>
                <TableCell sx={{ minWidth: '40%' }} align="left">
                  ID-Compra
                </TableCell>
                <TableCell align="right">Data</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <LinearProgress />
                  </TableCell>
                </TableRow>
              )}
              {inputSearch && rows.length === 0 && !loading && <TableNotFound />}
              {rows &&
                rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((rows, index) => (
                    <Row
                      key={index}
                      row={rows}
                      index={index}
                      viewProduct={viewProduct}
                      handleViewProduct={handleViewProduct}
                      open={open}
                      setOpen={setOpen}
                    />
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`} itens`
          }
          labelRowsPerPage="Por página:"
        />
      </Paper>
      <ProdutoModalInfo produto={viewProduct} handleProduto={handleCloseViewProdut} />
    </>
  );
}
